import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      minWidth: 56,
      color: theme.palette.primary.main,
      flexShrink: 0,
      display: 'inline-flex'
    },
    alignItemsFlexStart: {
      marginTop: 8
    },
    justifyContentCenter: {
      justifyContent: 'center'
    }
  });

export interface SectionHeaderIconProps
  extends React.HTMLAttributes<HTMLDivElement> {
  alignItems?: 'flex-start' | 'center';
  justify?: 'flex-start' | 'center';
}
type Props = SectionHeaderIconProps & WithStyles<typeof styles>;
const SectionHeaderIcon: React.FC<Props> = props => {
  const {
    alignItems = 'center',
    justify = 'flex-start',
    classes,
    children,
    className,
    ...rest
  } = props;

  const cn = clsx(
    classes.root,
    {
      [classes.alignItemsFlexStart]: alignItems === 'flex-start',
      [classes.justifyContentCenter]: justify === 'center'
    },
    className
  );

  return (
    <div {...rest} className={cn}>
      {children}
    </div>
  );
};

export default withStyles<'root', {}, SectionHeaderIconProps>(styles, {
  name: 'FdSectionHeaderIcon'
})(SectionHeaderIcon);
